import PathwayReportFiltersContainer from './pathway_report_filters_container';

const PathwayReportFilters = PathwayReportFiltersContainer;
export default PathwayReportFilters;
